// extracted by css-extract-rspack-plugin
export default {"logo":"_AXqlG","form":"nLRBXI"};